import {BASE_URL} from '@/services/api'
import {METHOD, request} from '@/utils/request'


let TEAM_LIST= `${BASE_URL}/team/list`
let TEAM_DETAIL = `${BASE_URL}/team/detail`
let DOCTOR_DETAIL = `${BASE_URL}/team/doctortDetail`
let CHECK_OPERATION_AUTH = `${BASE_URL}/team/checkAuth`
let FIND_SAMETEAM_DOCTORS= `${BASE_URL}/team/findSameTeamDoctors`
let FIND_SAMETEAM_MEMBERS= `${BASE_URL}/team/findSameTeamMembers`
let FIND_TEAM_MEMBERS= `${BASE_URL}/team/findTeamMembers`
let GET_ALL_TEAM_USERS= `${BASE_URL}/team/getAllTeamUsers`
let GET_PATIENT_BY_DOCTOR= `${BASE_URL}/team/getPatientsByDoctor`

export async function GetTeamList() {
  return request(TEAM_LIST, METHOD.GET)
}

export async function GetTeamDetail(team_id) {
  return request(TEAM_DETAIL, METHOD.POST, {
    team_id:team_id
  })
}

export async function GetDoctorDetail(doctor_id) {
  return request(DOCTOR_DETAIL, METHOD.POST, {
    doctor_id:doctor_id
  })
}

export async function CheckOperationAuth(patient_id) {
  return request(CHECK_OPERATION_AUTH, METHOD.POST, {
    patient_id:patient_id
  })
}

export async function FindSameTeamDoctors() {
  return request(FIND_SAMETEAM_DOCTORS, METHOD.POST)
}

export async function FindSameTeamMembers() {
  return request(FIND_SAMETEAM_MEMBERS, METHOD.POST)
}

export async function FindTeamMembers(params) {
  return request(FIND_TEAM_MEMBERS, METHOD.POST,params)
}

export async function getAllTeamUsers(params) {
  return request(GET_ALL_TEAM_USERS, METHOD.POST,params)
}

export async function getPatientsByDoctor(params) {
  return request(GET_PATIENT_BY_DOCTOR, METHOD.POST,params)
}

export default {
}
